var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-report",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14v4h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11v-4a2 2 0 0 0 -2 -2h-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11h4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15h3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportes);
export default __webpack_public_path__ + "static/media/reportes.a9a4498ffc1f3a322b34c422e6cc0028.svg";
export { ForwardRef as ReactComponent };